import {AssignmentModelV3} from 'resources/GeneratedModels/Assignment/AssignmentModel.v3';

import {assignmentExtensions} from './assignment.extensions';
import {assignmentValidators} from './assignment.validators';

AssignmentModelV3.extend(assignmentExtensions);
AssignmentModelV3.addValidators(assignmentValidators);

export {AssignmentModelV3};
